import React from 'react';
import SideBar from './SideBar';
import HeaderSection from './HeaderSection';

export default function CustomerDashboard() {
    
    return (
        <>
         <div className="container-scroller">
                <SideBar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <HeaderSection />
                        <h1>My Dashboard Page</h1>
                    </div>
                </div>
            </div>
        </>
    );
}
